import { CatHeading } from '@blocks-react/components/Heading';
import { CatBadge } from '@blocks-react/components/Badge';
import { capitalizeText } from '../../../common/utils';
import { equipmentInfoProps } from '../../types';
import styles from '../../customer-account.module.scss';

const EquipmentInfo = ({
  equipmentInfo,
  isNewInsight,
  isDeskTop = true
}: {
  equipmentInfo: equipmentInfoProps;
  isNewInsight: boolean;
  isDeskTop?: boolean;
}) => {
  return (
    <div className="d-flex flex-row align-items-center">
      {isNewInsight && isDeskTop && (
        <CatBadge
          isDot
          className={'cat-u-margin-right-md'}
          data-testid="cat-badge"
        />
      )}

      <img
        src={equipmentInfo.imageURL}
        alt={equipmentInfo.imageURL}
        className={styles['equipmentInfo_img']}
        loading="lazy"
      />
      <div className="d-flex flex-column cat-u-margin-left-sm">
        <CatHeading
          variant="footnote-bold"
          className={`${styles['equipmentInfo_truncate']} ${styles['equipmentInfo_nickName']}`}
        >
          {equipmentInfo.assetId}
        </CatHeading>
        <CatHeading
          variant={equipmentInfo.assetId ? 'footnote' : 'footnote-bold'}
          className={`${styles['equipmentInfo_truncate']} ${styles['equipmentInfo_model']}`}
        >
          {`${equipmentInfo.model} ${capitalizeText(equipmentInfo.equipmentFamily)}`}
        </CatHeading>
        <CatHeading
          variant="footnote"
          className={styles['equipmentInfo_serial']}
        >
          {equipmentInfo.serialNumber}
        </CatHeading>
      </div>
    </div>
  );
};
export default EquipmentInfo;
